import { useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { player } from 'src/client/player';
import useOnMount from 'src/common/hooks/useOnMount';
import { LocationAndLocalizationContext } from 'src/common/providers/LocationAndLocalizationProvider';
import { selectBreakpoint, selectIsDiscord, selectRouteProps } from 'src/common/selectors/app';
import { isProfile } from 'src/common/utils/guideItemTypes';
import { useShouldShowPlayer } from 'src/common/utils/playerStatus/shouldShowPlayer';
import BoostIntroPopover from './boost/BoostIntroPopover';
import { Player } from './Player';

function usePlayer() {
  const history = useHistory();
  const routeProps = useSelector(selectRouteProps);
  const isDiscord = useSelector(selectIsDiscord);
  const { locale, localizations } = useContext(LocationAndLocalizationContext);

  useOnMount(() => {
    const routeGuideId = routeProps?.guideContext?.guideId;
    const isProfileRoute = isProfile(routeGuideId);
    const enableFetchAutoplayGuideItem = !isProfileRoute && !isDiscord;

    player.init({
      locale,
      localizations,
      enableFetchAutoplayGuideItem,
      history,
    });
  });
}

export default function MiniPlayer() {
  const showPlayer = useShouldShowPlayer();
  const breakpoint = useSelector(selectBreakpoint);
  const routeProps = useSelector(selectRouteProps);
  const nextPlayButtonRef = useRef();

  usePlayer();

  if (!showPlayer) {
    return null;
  }

  return (
    <>
      <BoostIntroPopover breakpoint={breakpoint} nextPlayButtonRef={nextPlayButtonRef} />
      <Player
        breakpoint={breakpoint}
        disablePreroll={routeProps.disablePreroll}
        nextPlayButtonRef={nextPlayButtonRef}
      />
    </>
  );
}
